// services/legalRepresentativeDocumentService.js
import apiClient from '../api';

/**
 * Service pour gérer les documents des représentants légaux
 */
class LegalRepresentativeDocumentService {
  
  /**
   * Récupérer tous les documents d'un représentant légal
   * @param {number} legalRepresentativeId - ID du représentant légal (dans la table LegalRepresentatives)
   * @returns {Promise<Array>} Liste des documents du représentant
   */
  async getDocumentsByLegalRepresentativeId(legalRepresentativeId) {
    try {
      const response = await apiClient.get(
        `/api/LegalRepresentativeDocuments/legal-representatives/${legalRepresentativeId}/documents`
      );
      
      return {
        success: true,
        data: response.data,
        error: null
      };
    } catch (error) {
      // console.error('Error fetching legal representative documents:', error);
      return {
        success: false,
        data: [],
        error: error.response?.data?.message || error.message || 'Erreur lors du chargement des documents'
      };
    }
  }

  /**
   * Télécharger un document
   * @param {string} documentUrl - URL du document à télécharger
   * @param {string} fileName - Nom du fichier pour le téléchargement
   */
  async downloadDocument(documentUrl, fileName) {
    try {
      // Créer un lien temporaire pour le téléchargement
      const link = document.createElement('a');
      link.href = documentUrl;
      link.download = fileName || 'document';
      link.target = '_blank';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      return { success: true };
    } catch (error) {
      // console.error('Error downloading document:', error);
      return {
        success: false,
        error: 'Erreur lors du téléchargement du document'
      };
    }
  }

  /**
   * Afficher un document dans un nouvel onglet
   * @param {string} documentUrl - URL du document à afficher
   */
  async viewDocument(documentUrl) {
    try {
      window.open(documentUrl, '_blank');
      return { success: true };
    } catch (error) {
      // console.error('Error viewing document:', error);
      return {
        success: false,
        error: 'Erreur lors de l\'ouverture du document'
      };
    }
  }
}

// Export en tant que singleton
export default new LegalRepresentativeDocumentService();